import { render, staticRenderFns } from "./LocatorRegionList.vue?vue&type=template&id=d572ef28&"
import script from "./LocatorRegionList.vue?vue&type=script&lang=js&"
export * from "./LocatorRegionList.vue?vue&type=script&lang=js&"
import style0 from "./LocatorRegionList.vue?vue&type=style&index=0&id=d572ef28&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports